/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Dropdown1 } from '../../../../../../_metronic/partials'
import { ChatInner } from './ChatInner'
import { Chat } from '../core/_models'


const PrivateChat: FC = () => {
  return (
    <ChatInner   />

  )
}

export {PrivateChat}
